module.exports = __webpack_public_path__ + "img/loading-spinner.81cae3f.svg";